import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FooterWrapper, SocialIcon } from "./styles";
import { CtaLink, AElement } from "../../Elements";
import { getCountry } from "@website-builder/utilities-index";

const SOCIAL_ICONS_SPRITE =
	"https://res.cloudinary.com/springboard-images/image/upload/homepage-assets/new-homepage/social-sprite.png";

const FOOTER_LOGO_URL =
	"https://res.cloudinary.com/springboard-images/image/upload/homepage-assets/icons/all-logos.svg";

const Footer = (props) => {
	const {
		sectionOne,
		sectionTwo,
		sectionThree,
		sectionFour,
		legalLinks,
		socialLinks,
		Link,
		context,
		enableIndiaSocialLinks,
	} = props;

	// ToDo:
	// countryCode was used to change the country in footer, however, that code is removed now, so this will also have
	// to be removed
	const [countryCode, setCountryCode] = useState("www");

	useEffect(() => {
		const currentCountryCode = getCountry();
		setCountryCode(currentCountryCode);
	}, []);

	return (
		<FooterWrapper logoUrl={FOOTER_LOGO_URL}>
			<div className="linkSectionsWrapper">
				<div className="linkSection">
					<h6 className="name">{sectionOne.name}</h6>
					{sectionOne.links.map(
						({ label = "", link = "", type = "", target = "_self" }, index) => (
							<CtaLink
								Link={Link}
								type={type}
								value={link}
								className="link"
								key={`${label}-${index}`}
								target={target}
							>
								{label}
							</CtaLink>
						),
					)}
				</div>
				<div className="linkSection">
					<h6 className="name">{sectionTwo.name}</h6>
					{sectionTwo.links.map(
						({ label = "", link = "", type = "", target = "_self" }, index) => (
							<CtaLink
								Link={Link}
								type={type}
								value={link}
								className="link"
								target={target}
								key={`${label}-${index}`}
							>
								{label}
							</CtaLink>
						),
					)}
				</div>
				<div className="linkSection">
					<h6 className="name">{sectionThree.name}</h6>
					{sectionThree.links.map(
						({ label = "", link = "", type = "", target = "_self" }, index) => (
							<CtaLink
								Link={Link}
								type={type}
								value={link}
								className="link"
								target={target}
								key={`${label}-${index}`}
							>
								{label}
							</CtaLink>
						),
					)}
				</div>
				<div className="linkSection">
					<h6 className="name">{socialLinks.name}</h6>

					{enableIndiaSocialLinks ? (
						<span>
							<a
								href="https://www.facebook.com/springboardind/"
								rel="noopener noreferrer"
								target="_blank"
							>
								<SocialIcon
									data-bg={SOCIAL_ICONS_SPRITE}
									className="lazyload"
									backgroundPositionX={"0px"}
								></SocialIcon>
							</a>
							<a
								href="https://twitter.com/springboard_ind/"
								rel="noopener noreferrer"
								target="_blank"
							>
								<SocialIcon
									data-bg={SOCIAL_ICONS_SPRITE}
									className="lazyload"
									backgroundPositionX={"-25px"}
								></SocialIcon>
							</a>
							<a
								href="https://www.instagram.com/springboard_india/"
								rel="noopener noreferrer"
								target="_blank"
							>
								<SocialIcon
									data-bg={SOCIAL_ICONS_SPRITE}
									backgroundPositionX={"-50px"}
									className="lazyload"
								></SocialIcon>
							</a>
							<a
								href="https://www.linkedin.com/company/springboard-india/"
								rel="noopener noreferrer"
								target="_blank"
							>
								<SocialIcon
									data-bg={SOCIAL_ICONS_SPRITE}
									backgroundPositionX={"-75px"}
									className="lazyload"
								></SocialIcon>
							</a>
							<a
								href="https://medium.com/@springboard_ind/"
								rel="noopener noreferrer"
								target="_blank"
							>
								<SocialIcon
									data-bg={SOCIAL_ICONS_SPRITE}
									backgroundPositionX={"-100px"}
									className="lazyload"
								></SocialIcon>
							</a>
						</span>
					) : (
						<span>
							{socialLinks.links.map(
								({ icon = "", link = "", type = "", target = "" }) => (
									<a href={link} rel="noopener noreferrer" target={target}>
										<SocialIcon
											data-bg={icon.imageUrl}
											aria-label={icon.altTag}
											className="lazyload"
										></SocialIcon>
									</a>
								),
							)}
						</span>
					)}
					<h6 className="name">{sectionFour.name}</h6>
					{sectionFour.links.map(({ label = "", link = "" }, index) => (
						<a href={link} className="link" key={`${label}-${index}`}>
							{label}
						</a>
					))}
				</div>
			</div>
			<div className="footerLinks">
				<div class="logoSection">
					<a data-bg={FOOTER_LOGO_URL} className="logo lazyload" href="/"></a>
					<div className="copyright">Copyright {new Date().getFullYear()}</div>
				</div>
				<div class="legalItems">
					{legalLinks.map(({ label, link, type, target = "_self" }, index) => (
						<CtaLink
							Link={Link}
							type={type}
							value={link}
							className="link"
							target={target}
							key={`${label}-${index}`}
						>
							{label}
						</CtaLink>
					))}
				</div>
			</div>
		</FooterWrapper>
	);
};

export const LinkWithLabelType = PropTypes.shape({
	label: PropTypes.string,
	link: PropTypes.string,
	type: PropTypes.oneOf(["internal", "external", "hash"]),
});

export const LinkWithIconType = PropTypes.shape({
	icon: PropTypes.shape({
		imageUrl: PropTypes.string,
		altTag: PropTypes.string,
	}),
	link: PropTypes.string,
	type: PropTypes.oneOf(["internal", "external"]),
	target: PropTypes.oneOf(["_self", "_blank"]),
});

export const LinkSectionType = PropTypes.shape({
	name: PropTypes.string,
	links: PropTypes.arrayOf(LinkWithLabelType),
});

Footer.propTypes = {
	legalLinks: PropTypes.arrayOf(LinkWithLabelType),
	sectionOne: LinkSectionType,
	sectionTwo: LinkSectionType,
	sectionThree: LinkSectionType,
	sectionFour: LinkSectionType,
	socialLinks: PropTypes.shape({
		name: PropTypes.string,
		links: PropTypes.arrayOf(LinkWithIconType),
	}),
	Link: PropTypes.func,
	enableIndiaSocialLinks: PropTypes.bool,
};

Footer.defaultProps = {
	legalLinks: [],
	sectionOne: {
		name: "",
		links: [],
	},
	sectionTwo: {
		name: "",
		links: [],
	},
	sectionThree: {
		name: "",
		links: [],
	},
	sectionFour: {
		name: "",
		links: [],
	},
	socialLinks: {
		name: "",
		links: [],
	},
	Link: AElement,
	enableIndiaSocialLinks: false,
};

export default Footer;
